import { Box, ButtonBase, Tooltip } from "@mui/material"
import { useNavigate } from "react-router"

const SideNavItem = (props) => {
  const { active = false, disabled, icon, path, title, collapsed, badgeCount = 0 } = props

  const nav = useNavigate()

  const handleClick = () => nav(path)

  const showBadge = badgeCount > 0
  const badgeLabel = badgeCount > 9 ? "9+" : String(badgeCount)

  const badge = showBadge ? (
    <Box
      sx={{
        minWidth: 18,
        height: 18,
        borderRadius: "100%",
        backgroundColor: "#fc5371",
        color: "#FFFFFF",
        fontSize: "11px",
        fontWeight: 600,
        lineHeight: 1,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        px: badgeCount > 9 ? "4px" : 0,
        animation: "sidenav-pulse 1.5s infinite",
        boxShadow: "0 0 0 0 rgba(252, 83, 113, 0.6)",
        "@keyframes sidenav-pulse": {
          "0%": {
            transform: "scale(1)",
            boxShadow: "0 0 0 0 rgba(252, 83, 113, 0.6)"
          },
          "70%": {
            transform: "scale(1.1)",
            boxShadow: "0 0 0 8px rgba(252, 83, 113, 0)"
          },
          "100%": {
            transform: "scale(1)",
            boxShadow: "0 0 0 0 rgba(252, 83, 113, 0)"
          }
        }
      }}
    >
      {badgeLabel}
    </Box>
  ) : null

  const button = (
    <ButtonBase
      sx={{
        alignItems: "center",
        borderRadius: "10px",
        display: "flex",
        justifyContent: collapsed ? "center" : "flex-start",
        px: collapsed ? "0px" : "12px",
        py: "8px",
        textAlign: "left",
        width: "100%",
        position: "relative",
        overflow: "hidden",
        transition: "all 0.15s ease",
        ...(active && {
          backgroundColor: "rgba(99, 102, 241, 0.12)"
        }),
        "&:hover": {
          backgroundColor: active
            ? "rgba(99, 102, 241, 0.16)"
            : "rgba(255, 255, 255, 0.06)"
        }
      }}
      onClick={handleClick}
    >
      {/* Active accent bar */}
      {active && (
        <Box
          sx={{
            position: "absolute",
            left: 0,
            top: "20%",
            bottom: "20%",
            width: 3,
            borderRadius: "0 3px 3px 0",
            backgroundColor: "primary.main"
          }}
        />
      )}
      {icon && (
        <Box
          component="span"
          sx={{
            alignItems: "center",
            display: "inline-flex",
            justifyContent: "center",
            flexShrink: 0,
            width: collapsed ? 40 : "auto",
            mr: collapsed ? 0 : 1.5,
            color: active ? "primary.main" : "neutral.400",
            transition: "color 0.15s ease",
            position: "relative"
          }}
        >
          {icon}
          {collapsed && showBadge && (
            <Box
              sx={{
                position: "absolute",
                top: -4,
                right: 4,
                pointerEvents: "none"
              }}
            >
              {badge}
            </Box>
          )}
        </Box>
      )}
      {!collapsed && (
        <Box
          component="span"
          sx={{
            color: active ? "common.white" : "neutral.400",
            flexGrow: 1,
            fontFamily: (theme) => theme.typography.fontFamily,
            fontSize: 13,
            fontWeight: active ? 600 : 500,
            lineHeight: "24px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            transition: "color 0.15s ease",
            ...(disabled && {
              color: "neutral.600"
            })
          }}
        >
          {title}
        </Box>
      )}
      {!collapsed && showBadge && (
        <Box sx={{ ml: 1, flexShrink: 0 }}>{badge}</Box>
      )}
    </ButtonBase>
  )

  if (collapsed) {
    return (
      <li>
        <Tooltip title={title} placement="right" arrow>
          {button}
        </Tooltip>
      </li>
    )
  }

  return <li>{button}</li>
}

export default SideNavItem
